<template>
  <PSUnitArticle />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
